/* jQuery is assumed to be loaded */

/*----------------------------------------------------------------------
 * Init compoents already loaded by scrit src
 */

/* Datepicker */
$(() => {
    if ($.datepicker !== undefined) {
        let lang = $('html').attr('lang');
        if (!lang) lang = 'es';
        if(lang === 'en') lang = 'en-GB'
        const options = $.extend(
            {},
            $.datepicker.regional[lang],
            {
                dateFormat: 'dd/mm/yy',
                firstDay: 1,
            }
        );
        $('.datepicker').datepicker(options);
    }
});

/*----------------------------------------------------------------------
 * Load some libraries shared code (that are not the components below
 * and don't need to be called init)
 */

/* Example:
 * import './libraries/my-library.js' */


/*----------------------------------------------------------------------
 * Load fixed components
 */

/* Login client */
import componentLoginClient from './components/login-client';
componentLoginClient.init();

/* Cart in header */
import componentHeaderCart from './components/header-cart';
componentHeaderCart.init();

/* Cart icon in header */
import componentCartIconHeader from './components/cart-icon-header'
componentCartIconHeader.init();

/* ProductesMenu desktop */
import componentHeaderCategoriesWebDesktop from './components/header-categories-web-desktop';
componentHeaderCategoriesWebDesktop.init();

/* ProductesMenu mobile */
import componentHeaderCategoriesWebMobile from './components/header-categories-web-mobile';
componentHeaderCategoriesWebMobile.init();

/* Html block */
import componentHtmlblock from './components/htmlblock';
componentHtmlblock.init();

/* Doofinder */
import componentDoofinderInput from './components/doofinder-input';
componentDoofinderInput.init();

/*--------------------------------------------------------------------------------
 * Load fixed libraries
 */

/*--------------------------------------------------------------------------------
 * Load optional components
 */

/* Contact form */
if (document.getElementsByClassName('component-contact-form').length > 0) {
    import('./components/contact-form').then((module) => {
        module.default.init();
    });
}

/* Babylist Xec Regal Form */
if ($('.component-babylist-xec-regal-form').length > 0) {
    import('./components/babylist-xec-regal-form').then((module) => {
        module.default.init();
    });
}

/* Validar xec regal */
if ($('.component-validar-xec-regal').length > 0) {
    import('./components/validar-xec-regal').then((module) => {
        module.default.init();
    });
}

/* Popup banner */
if ($('.component-popup-banner').length > 0) {
    import('./components/popup-banner').then((module) => {
        module.default.init();
    });
}

/* Show/hide babylist family pass */
if ($('.component-babylist-show-hide-family-pass').length > 0) {
    import('./components/babylist-show-hide-family-pass').then((module) => {
        module.default.init();
    });
}

/* Inline read more */
if ($('.component-inline-read-more').length > 0) {
    import('./components/inline-read-more').then((module) => {
        module.default.init();
    });
}


/*----------------------------------------------------------------------
 * Load view scripts.
 * Aquests script de vista es carreguen només si es detecta la vista.
 */

/* Header */
import './views/partials-header';

/* Productlist */
if ($('section.productlist').length > 0) {
    import('./views/productlist');
}

/* Product */
if ($('section.product').length > 0) {
    import('./views/product');
}

/* Product customizer */
if ($('section.product-customizer').length > 0) {
    import('./views/product-customizer');
}

/* Client profile */
if ($('section.client-profile').length > 0) {
    import('./views/client-profile.js');
}

/* Checkout: layout and view for layout process */
if ($('section.checkout').length > 0) {
    import('./views/checkout.js');
}

/* Cart in content */
if ($('.component-cart-in-content').length > 0) {
    import('./components/cart-in-content.js').then((module) => {
        module.default.init();
    });
}

/* Giftvoucher voucher data */
if ($('section.giftvoucher-voucher-data').length > 0) {
    import('./views/giftvoucher-voucher-data.js');
}

/* Babylist parents */
if ($('section.babylist-parents-list').length > 0) {
    import('./views/babylist-parents-list.js');
}

/* Babylist parents resum */
if ($('section.babylist-parents-list-resum').length > 0) {
    import('./views/babylist-parents-list-resum.js');
}

/* Babylist parents cart */
if ($('section.babylist-parents-cart').length > 0) {
    import('./views/babylist-parents-cart.js');
}

/* Babylist family cart */
if ($('section.babylist-family-cart').length > 0) {
    import('./views/babylist-family-cart.js');
}
